export default "__VITE_ASSET__B3wgCiG9__"